export default __webpack_public_path__ + "static/media/hht1_ep13_minisitcom_04.665d9078.png";